/////////////////////////////////////////////////V5CommentStart
// myLocationInfo march 1
// Mar14, more docs
// this is broken rest trying to fix from mar 25
// 2021-03-16 - Big Cleanup
// 2023-03-5 - Blogs api added
// DDFIX - is the error handling ok here getClientIPaxios needs work
/////////////////////////////////////////////////V5CommentEnd

import axios from 'axios'
import queryString from 'querystring'
import haversine from 'haversine'
import { getLocationFromZipCode } from './location'

let blogPosts = {}

//---------------------------------------
// DDFIX do we really need zip code
//---------------------------------------
export function getBlogPostsREST(zipCode,redirURL) 
{
  console.log(`CFD_FUNC_REST_getblogPostsREST:`+ zipCode +'|' +redirURL)            
  if (zipCode in blogPosts) 
    return Promise.resolve(blogPosts[zipCode])
  const url = '/api/blogs?' + queryString.stringify({ zipCode,redirURL })
  //const url = '/api/featured-links?' + queryString.stringify({ zipCode })
  console.log(`CFD_FUNC_REST_getblogPostsREST2:` + zipCode +  queryString + url  )            
  
  return axios.get(url).then(({ data }) => {
    if (data.status !== 'OK') {
      throw new Error(data.statusMessage)
    }
    blogPosts = {}
    blogPosts[zipCode] = data.result
    console.log(`CFD_FUNC_REST_getblogPostsREST3:` + JSON.stringify(data.result))            
    return data.result
  })
}  //end getblogPosts




let filters = null // memoize getFilters response
//---------------------------------------
//
//---------------------------------------
export function getFilters() {
  console.log(`CFD_FUNC_REST_getFilters:`)
  if (filters) return Promise.resolve(filters)
  return axios
    .get(`/api/filters/inventory`)
    .catch(error => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data)
        console.log(error.response.status)
        console.log(error.response.headers)
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
      console.log(error.config)
      throw Error(error)
    })
    .then(res => {
      if (res.data.status !== 'OK') {
        throw new Error(
          `InventoryFilter: ${res.data.status} ${res.data.message}`
        )
      }
      filters = res.data.result
      return res.data.result
    })
} // end getFilters

let featuredLinks = {}

//---------------------------------------
//
//---------------------------------------
export function getFeaturedLinks(zipCode) {
  console.log(`CFD_FUNC_REST_getFeaturedLinks:`)
  if (zipCode in featuredLinks) return Promise.resolve(featuredLinks[zipCode])
  const url = '/api/featured-links?' + queryString.stringify({ zipCode })
  console.log(`CFD_FUNC_REST_getFeaturedLinks2:`, zipCode, queryString, url)

  return axios.get(url).then(({ data }) => {
    if (data.status !== 'OK') {
      throw new Error(data.statusMessage)
    }
    featuredLinks = {}
    featuredLinks[zipCode] = data.result
    console.log(`CFD_FUNC_REST_getFeaturedLinks3:`, data.result)
    return data.result
  })
} //end getFeaturedLinks

let dealers = {}
//---------------------------------------
//
//---------------------------------------
export async function getDealerByDid({ did, myLocationInfo, ...props }) {
  console.log(`CFD_FUNC_REST_getDealerByDid:`)
  if (did in dealers) return dealers[did]
  const url = `/api/dealers/${did}`
  const res = await axios.get(url)
  if (res.statusText !== 'OK')
    throw new Error(`getDealerByDid(): ${res.statusText}: ${url}`)
  if (res.data.status !== 'OK')
    throw new Error(`getDealerByDid(): ${res.data.status}: ${url}`)
  const dealer = res.data.result.items[0]
  if (!dealer || !dealer.location)
    throw new Error(`getDealerByDid(): Couldn't fetch dealer ${did}`)
  if (!(dealer.location.latitude && dealer.location.longitude)) {
    try {
      const location = await getLocationFromZipCode(dealer.location)
      dealer.location = { ...dealer.location, ...location }
    } catch (err) {}
  }
  try {
    const distance = haversine(myLocationInfo, dealer.location, {
      unit: 'mile',
    })
    if (isNaN(distance)) throw Error('NaN')
    dealer.location.distance = distance
  } catch (err) {}
  dealers = {}
  dealers[did] = dealer
  return dealer
} // end getDealerByDid

//---------------------------------------
// you suck
//---------------------------------------
//console.log(`CFD_FUNC_REST_getInventoryItemsByVin:`)
export const getInventoryItemsByVin = items =>
  Promise.all(
    items.map((vin, i) =>
      getInventory({ vin }).catch(err => {
        console.error(`DataView.load(): axios: ${err}`)
        return { items: [{ vin, error: true }] }
      })
    )
  )

//---------------------------------------
//
//---------------------------------------
export const getDealers = ({ did, search }) => {
  console.log(`CFD_FUNC_REST_getDealers:`)
  let p
  if (did) {
    p = axios.get(`/api/dealers/${did}`)
  } else {
    const { zipCode } = search
    p = getLocationFromZipCode({ zipCode })
      .then(position => {
        const { latitude, longitude } = position
        return { latitude, longitude }
      })
      .catch(err => ({}))
      .then(coords =>
        axios.get(
          `/api/dealers?${queryString.stringify({ ...search, ...coords })}`
        )
      )
  }
  return p
    .catch(err => {
      console.error(`DataView.load(): axios: ${err}`)
      throw new Error(err)
    })
    .then(result => {
      if ('data' in result && result.data.status === 'OK') {
        return result.data.result
      }
      console.error(`DataView.load(): REST API error: ${result.data.message}`)
      throw new Error(
        `${result.data ? result.data.message : 'Empty data result'}`
      )
    })
} // end getDealers

//---------------------------------------
//
//---------------------------------------
export const getInventory = ({ vin, did, search, latitude, longitude }) => {
  // ddfix this is subpar
  let p
  if (vin) {
    p = axios.get(`/api/inventory/${vin}`)
  } else if (did) {
    p = axios.get(
      `/api/dealers/${did}/inventory?${queryString.stringify(search)}`
    )
  } else if (longitude && latitude && false) {
    // ddfix, is this broken?
    console.log(`CFD_FUNC_REST: Geinventoryalso calling GetlcofromzipCFDCFDx `)
    const { zipCode } = search
    const localcoords = { latitude, longitude, zipCode }
    console.log(
      `CFD_FUNC_REST_getInventory:HOCUSPOCUS NEW BITS `,
      `?${queryString.stringify({ ...search, ...localcoords })}`
    )

    p = axios.get(
      `/api/inventory?${queryString.stringify({ ...search, ...localcoords })}`
    )
  } else {
    const { zipCode } = search
    console.log(
      `CFD REST: Geinventoryalso calling Getlcofromzip  this is broke `
    )
    console.log(
      `CFD_FUNC_REST_getInventory:         why is it doing it this way????? `
    )
    p = getLocationFromZipCode({ zipCode })
      .then(position => {
        const { latitude, longitude } = position
        return { latitude, longitude }
      })
      .catch(err => ({}))
      .then(coords =>
        axios.get(
          `/api/inventory?${queryString.stringify({ ...search, ...coords })}`
        )
      )
  }
  return p
    .catch(err => {
      //console.error(`DataView.load(): axios-BEATLES---------------------------------: ${err}`)
      throw new Error(err)
    })
    .then(result => {
      if ('data' in result && result.data.status === 'OK') {
        return result.data.result
      }
      //console.error(`DataView.load(): REST API error: ${result.data.message}`)
      throw new Error(
        `${result.data ? result.data.message : 'Empty data result'}`
      )
    })
} //end getInventory

//---------------------------------------
//
//---------------------------------------
export const getFeaturedInventory = ({ vin, search }) => {
  console.log(`CFD_FUNC_REST_getFeaturedInventory:`)
  let p

  if (vin) {
    p = axios.get(
      `/api/featured-inventory/${vin}?${queryString.stringify({
        ...search,
      })}`
    )
  } else {
    const { zipCode, latitude, longitude } = search
    p = getLocationFromZipCode({ zipCode, latitude, longitude })
      .then(position => {
        const { latitude, longitude } = position
        return { latitude, longitude }
      })
      .catch(err => ({}))
      .then(coords =>
        axios.get(
          `/api/featured-inventory?${queryString.stringify({
            ...search,
            ...coords,
          })}`
        )
      )
  }
  return p
    .catch(err => {
      console.error(`DataView.load(): axios: ${err}`)
      throw new Error(err)
    })
    .then(result => {
      if ('data' in result && result.data.status === 'OK') {
        return result.data.result
      }
      console.error(`DataView.load(): REST API error: ${result.data.message}`)
      throw new Error(
        `${result.data ? result.data.message : 'Empty data result'}`
      )
    })
} //end getFeaturedInventory

//---------------------------------------
//
//---------------------------------------
export function postDealerSignUp(data) {
  console.log(`CFD_FUNC_REST_postDealerSignUp:`)
  return axios
    .post(`/api/admin/dealer-application`, queryString.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    .then(res => res.data.result)
} // end postDealerSignUp

//---------------------------------------
//
//---------------------------------------
export function postContactDealer(vin, data) {
  console.log(`CFD_FUNC_REST_postContactDealer:`)
  return axios
    .post(`/api/inventory/${vin}/contact`, queryString.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    .then(res => res.data.result)
} //end postContactDealer

//---------------------------------------
//  using this service, but the location is bad... so just getting IP here
//---------------------------------------
export const getClientIPaxios = async () => {
  console.log(`CFD_FUNC_REST_getClientIPAxios1:`)
  //DDFIX Weak error handling
  const res = await axios.get('https://geolocation-db.com/json/')
  console.log(`CFD_FUNC_REST_getClientIPAxios2:`)

  console.log(res.data)
  //
  return res.data.IPv4
  // setIP(res.data.IPv4)
}

//end postContactDealer



// WEBPACK FOOTER //
// ./src/utils/rest.js